import MuiModal from '@mui/material/Modal'
import { XMarkIcon } from '@heroicons/react/24/outline'

import ModalBackdrop from './ModalBackdrop'
import ModalContent from './ModalContent'
import { mergeClassName } from '../../utils/mergeClassName'

export type ModalProps = {
  open: boolean
  onClose?: () => void
  showCloseIcon?: boolean
  className?: string
  style?: React.CSSProperties
  children?: React.ReactNode
}

const Modal: React.FC<ModalProps> = ({
  open,
  onClose,
  showCloseIcon = true,
  className,
  style,
  children,
}) => {
  const onBackdropClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()

    if (event.target instanceof HTMLElement && event.target.dataset.component === 'backdrop') {
      onClose?.()
    }
  }

  return (
    <MuiModal
      open={open}
      onClose={() => onClose?.()}
      hideBackdrop
      className="z-[9999]"
      disableEnforceFocus
      disableRestoreFocus
    >
      <div>
        <ModalBackdrop
          onClick={onBackdropClick}
          data-state={open ? 'open' : 'closed'}
        >
          <div className="flex h-screen flex-col items-center justify-center px-[5-vw] py-[5vh]" data-component="backdrop">
            <ModalContent
              data-state={open ? 'open' : 'closed'}
              className={mergeClassName(
                'overflow-y-auto !rounded-xl',
                className,
              )}
              style={style}
            >
              { showCloseIcon && (
                <div
                  className="absolute right-4 top-4 z-50 -m-2 cursor-pointer rounded-full bg-white p-2 opacity-70 transition-opacity hover:opacity-100"
                  data-state={open ? 'open' : 'closed'}
                >
                  <XMarkIcon className="size-6" onClick={onClose} />
                </div>
              ) }

              { children }
            </ModalContent>
          </div>
        </ModalBackdrop>
      </div>
    </MuiModal>
  )
}

export default Modal
